// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__4yNNZ","resendInfoText":"OnGoingPaymentBox_resendInfoText__3XHyz"};